import BaseGridController from "../common/grid/base_grid_controller";
import {formatMoney} from "../../../js/formatters";
import urgentMarkerUrl from "../../../assets/icons/urgent-map-marker.svg";

export default class extends BaseGridController {
  async fetchItems(searchParams: URLSearchParams): Promise<any[]> {
    const url = new URL('/public/announcements', window.location.href);
    url.search = searchParams.toString();

    const response = await fetch(url, {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return await response.json();
  }

  createItemElement(item: any): HTMLElement | null {
    const template = document.getElementById('announcement-template') as HTMLTemplateElement;
    if (!template) {
      return null
    }

    const clone = template.content.cloneNode(true) as HTMLElement;

    const urgentIcon = clone.querySelector<HTMLImageElement>('[data-announcement-urgent-icon]');
    if (urgentIcon) {
      if (item.urgent) {
        urgentIcon.src = urgentMarkerUrl;
      } else {
        urgentIcon.remove();
      }
    }

    if (item.advertising_thumb_url) {
      const headerImage = clone.querySelector<HTMLImageElement>('[data-header-image]');
      if (headerImage) headerImage.src = item.advertising_thumb_url;
    } else {
      const headerImageContainer = clone.querySelector<HTMLDivElement>('[data-header-image-container]');
      if (headerImageContainer) headerImageContainer.remove();
    }

    const announcementLink = clone.querySelector<HTMLLinkElement>('[data-announcement-path]');
    if (announcementLink) announcementLink.href += `/${item.id}`;

    const titlePlaceholder = clone.querySelector('[data-title]');
    if (titlePlaceholder) titlePlaceholder.innerHTML = item.title;

    const shortDescriptionPlaceholder = clone.querySelector('[data-short-description]');
    if (shortDescriptionPlaceholder) shortDescriptionPlaceholder.innerHTML = item.short_description;

    const minCostPlaceholder = clone.querySelector('[data-min-cost]');
    if (minCostPlaceholder) minCostPlaceholder.textContent = formatMoney(item.min_cost);

    return clone;
  }
}
